exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.comments-section[data-v-0878755a] {\n    width: 100%;\n}\n", ""]);

